<template>
  <div class="dashboard">
    <div class="dashboard-head__title fs-25 black--text font-weight-medium">
      Dashboard
    </div>
    <div class="dashboard__body mt-4">
      <v-row>
        <v-col class="no-flex">
          <v-card
            class="dashboard__body__card d-flex justify-center align-center flex-column elevation-4"
            height="237"
            width="380"
            @mouseover="importNormal = importHover"
            @mouseleave="importNormal = initialImportNormal"
            @click="showComingSoonModal = true"
          >
            <div class="dashboard__body__card__logo-bg rounded-circle d-flex justify-center">
              <v-img size="43" :src="importNormal" />
            </div>
            <v-card-title class="text-h5 font-weight-bold">Import</v-card-title>
            <v-card-subtitle class="pt-2 text-center">
              <div>
                <span>Click this card for import related actions</span>
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col class="no-flex">
          <v-card
            class="dashboard__body__card d-flex justify-center align-center flex-column elevation-4"
            height="237"
            width="380"
            @mouseover="exportNormal = exportHover"
            @mouseleave="exportNormal = initialExportNormal"
            @click="$router.push({ name: 'dashboard.export' })"
          >
            <div class="dashboard__body__card__logo-bg rounded-circle d-flex justify-center">
              <v-img size="43" :src="exportNormal" />
            </div>
            <v-card-title class="text-h5 font-weight-bold">Export</v-card-title>
            <v-card-subtitle class="pt-2 text-center">
              <div>
                <span>Click this card for export related actions</span>
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <ImportComingSoonModal
      v-if="showComingSoonModal"
      @notify-me="sendNotificationRequest"
      @close-coming-soon-modal="showComingSoonModal = false"
    />
  </div>
</template>
<script>
import ImportComingSoonModal from "../components/ComingSoonImportModal";
import * as AT from "../store/actionTypes";
import { GET_ESANCHIT_SUPPORTING_DOC } from "@/modules/DashboardModule/modules/ImportExportModule/store/actionTypes";

export default {
  name: "Dashboard",
  components: {
    ImportComingSoonModal
  },
  data() {
    return {
      showComingSoonModal: false,
      exportNormal: `/img/export_normal.svg`,
      initialExportNormal: `/img/export_normal.svg`,
      exportHover: `/img/export_hovered.svg`,
      importNormal: `/img/import_normal.svg`,
      initialImportNormal: `/img/import_normal.svg`,
      importHover: `/img/import_hovered.svg`
    };
  },
  watch: {
    globalTimePeriodId(newVal, oldVal) {
      if (newVal !== null) {
        oldVal;
        this.getEsanchits(newVal);
      }
    }
  },
  methods: {
    sendNotificationRequest() {
      this.$store
        .dispatch(AT.ADD_NOTIFICATION_REQUEST)
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.showComingSoonModal = false;
        });
    },
    getEsanchits(timePeriodId) {
      this.loading = true;
      this.$store
        .dispatch(GET_ESANCHIT_SUPPORTING_DOC, timePeriodId)
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    globalTimePeriodId() {
      return this.$store.getters.globalTimePeriod;
    }
  }
};
</script>
<style lang="scss">
@import "../../../styles/settings/index";

.dashboard__body__card {
  border: 4px solid $brand-light-grey;
  border-radius: 3px;

  &__logo-bg {
    height: 86px;
    width: 86px;
    background: $brand-light-grey;
  }
  &:hover {
    color: white;
    background: $brand-primary;
    border: 4px solid $brand-primary;

    .v-card__subtitle {
      color: white;
    }
  }
  &:hover & {
    &__logo-bg {
      background: white !important;

      .v-icon {
        color: $brand-primary;
      }
    }
  }
}
</style>
